"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function GoogleAnalyticsZero() {
    return {
        event: '',
        eventAction: '',
        eventCategory: '',
        eventContent: '',
        eventContext: '',
        eventElementName: '',
        eventElementType: '',
        eventFormDesign: '',
        eventFormName: '',
        eventFormVendor: '',
        eventFormVersion: '',
        eventLabel: '',
        eventStep: '',
        eventStepType: '',
        eventFieldNumber: '',
        eventType: '',
        eventValue: '',
    };
}
exports.default = GoogleAnalyticsZero;
